import { render, staticRenderFns } from "./OrderStatusGif.vue?vue&type=template&id=b6fa334e&scoped=true&"
import script from "./OrderStatusGif.vue?vue&type=script&lang=js&"
export * from "./OrderStatusGif.vue?vue&type=script&lang=js&"
import style0 from "./OrderStatusGif.vue?vue&type=style&index=0&id=b6fa334e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6fa334e",
  null
  
)

export default component.exports